import { useState } from "react";
import type { Faq } from "@/mocks/articles";

type Props = {
  items: Faq[];
};

export default function FaqAccordion({ items }: Props) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className="divide-y divide-background-200 border-y border-background-200">
      {items.map((item, index) => {
        const open = openIndex === index;
        return (
          <article key={item.q}>
            <h3 className="m-0">
              <button
                type="button"
                onClick={() => setOpenIndex(open ? null : index)}
                aria-expanded={open}
                className="flex w-full cursor-pointer items-start justify-between gap-4 py-5 text-left"
              >
                <span className={`font-heading text-base font-semibold transition-colors md:text-lg ${open ? "text-primary-600" : "text-foreground-900"}`}>
                  {item.q}
                </span>
                <i
                  className={`mt-1 shrink-0 text-xl text-foreground-500 transition-transform ${open ? "rotate-180 text-primary-600" : ""}`}
                  aria-hidden="true"
                >
                  {open ? "ri-subtract-line" : "ri-add-line"}
                </i>
              </button>
            </h3>
            {open && (
              <div className="pb-6 pr-8 text-sm leading-loose text-foreground-600">
                <p>{item.a}</p>
              </div>
            )}
          </article>
        );
      })}
    </div>
  );
}